export class InputBase<T> {
  value: T

  key: string

  label: string

  required: boolean

  controlType: string

  type: string

  options: Option[]

  constructor(
    options: {
      value?: T
      key?: string
      label?: string
      required?: boolean
      controlType?: string
      type?: string
      options?: Option[]
    } = {},
  ) {
    this.value = options.value
    this.key = options.key || ''
    this.label = options.label || ''
    this.required = !!options.required
    this.controlType = options.controlType || ''
    this.type = options.type || ''
    this.options = options.options || []
  }
}

export type Option = {
  key: string | number
  value: string
}
